module.exports = __webpack_public_path__ + "static/media/7f_website_logo_Gold_shk.fd6df7ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/7f_website_logo_Gold_shk.jpg
// module id = 114
// module chunks = 0